"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableContainerSchema = void 0;
exports.TableContainerSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/table-container.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "TableContainer",
    "description": "A table container holds multiple tables.",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "contents": {
            "type": "array",
            "items": {
                "anyOf": [
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/table.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/results-table.schema.json"
                    }
                ]
            }
        },
        "type": {
            "type": "string",
            "enum": [
                "attributes:table-container"
            ]
        }
    },
    "required": [
        "contents",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFibGUtY29udGFpbmVyLnNjaGVtYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9tb2R1bGVzL2F0dHJpYnV0ZXMvdGFibGUtY29udGFpbmVyLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLG9CQUFvQixHQUFHO0lBQ2xDLEtBQUssRUFBRSx3RUFBd0U7SUFDL0UsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsZ0JBQWdCO0lBQ3pCLGFBQWEsRUFBRSwwQ0FBMEM7SUFDekQsTUFBTSxFQUFFLFFBQVE7SUFDaEIsc0JBQXNCLEVBQUUsS0FBSztJQUM3QixZQUFZLEVBQUU7UUFDWixVQUFVLEVBQUU7WUFDVixNQUFNLEVBQUUsT0FBTztZQUNmLE9BQU8sRUFBRTtnQkFDUCxPQUFPLEVBQUU7b0JBQ1A7d0JBQ0UsTUFBTSxFQUFFLFFBQVE7d0JBQ2hCLE1BQU0sRUFBRSw4REFBOEQ7cUJBQ3ZFO29CQUNEO3dCQUNFLE1BQU0sRUFBRSxRQUFRO3dCQUNoQixNQUFNLEVBQUUsc0VBQXNFO3FCQUMvRTtpQkFDRjthQUNGO1NBQ0Y7UUFDRCxNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04sNEJBQTRCO2FBQzdCO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLFVBQVU7UUFDVixNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=